(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-circle-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('category-circle-navigation')) return;

    const stickyChromeSelector = '.shopify-section--header, .shopify-section--announcement-bar';

    class CategoryCircleNavigation extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        this.ticking = false;
        this.boundary = null;
        this.onViewportChange = this.scheduleUpdate.bind(this);
        // On unload the outgoing section is still the event target and still in
        // the document, so refreshing synchronously can re-cache the very element
        // about to be removed — it then reports a zero rect and the nav stays
        // hidden. Deferring to the next task lets the mutation land first, the
        // same reason assets/uptown-bundle-bar.js defers its own re-observe.
        this.onSectionMutation = () => {
          window.clearTimeout(this.boundaryRefreshTimer);
          this.boundaryRefreshTimer = window.setTimeout(() => this.refreshBoundary(), 0);
        };
        this.onSectionSelect = this.handleSectionSelect.bind(this);
        this.onSectionDeselect = this.handleSectionDeselect.bind(this);

        window.addEventListener('scroll', this.onViewportChange, { passive: true });
        window.addEventListener('resize', this.onViewportChange, { passive: true });
        document.addEventListener('shopify:section:load', this.onSectionMutation);
        document.addEventListener('shopify:section:unload', this.onSectionMutation);
        // Reordering does not load or unload anything, but it can move the
        // boundary element above this nav, which would leave the cached
        // reference pointing at the wrong sibling and strand the nav hidden.
        document.addEventListener('shopify:section:reorder', this.onSectionMutation);
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
        // Selecting a category block emits the block pair, not the section pair.
        // Without these, editing a single circle while the nav is past its hide
        // boundary scrolls the merchant to something invisible.
        document.addEventListener('shopify:block:select', this.onSectionSelect);
        document.addEventListener('shopify:block:deselect', this.onSectionDeselect);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onViewportChange);
          this.resizeObserver.observe(this);
          document.querySelectorAll(stickyChromeSelector).forEach((element) => this.resizeObserver.observe(element));
        }

        this.refreshBoundary();
        this.setupVideos();
      }

      /*
       * Nothing here runs unless a circle actually uses a video: the Liquid
       * sets data-has-video, so the common case costs one attribute check and
       * no DOM query at all.
       *
       * When there is a video, video_tag is rendered with autoplay: false and
       * playback is decided here instead of by the parser, so that:
       *   - reduced-motion visitors keep the poster frame
       *   - Save-Data visitors are never charged for a decorative clip
       *   - off-screen clips are neither fetched nor decoded
       * preload is forced to none up front and only raised on intersection,
       * which matters most on mobile where these sit below the fold.
       */
      setupVideos() {
        if (!this.hasAttribute('data-has-video')) return;
        if (!this.querySelector('.category-circle-nav__video')) return;

        // Save-Data is read once: it is a connection property with no change
        // event, so there is nothing to subscribe to.
        if (navigator.connection && navigator.connection.saveData) return;

        // Reduced motion is a live preference. Sampling it once would leave
        // clips playing for someone who turns it on mid-visit, while every CSS
        // animation in this section stops immediately — so follow the query.
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionPreferenceChange = () => {
          if (this.motionQuery.matches) {
            this.stopVideos();
          } else {
            this.startVideos();
          }
        };

        if (this.motionQuery.addEventListener) {
          this.motionQuery.addEventListener('change', this.onMotionPreferenceChange);
        } else if (this.motionQuery.addListener) {
          // Safari below 14 predates addEventListener on MediaQueryList.
          this.motionQuery.addListener(this.onMotionPreferenceChange);
        }

        if (!this.motionQuery.matches) this.startVideos();
      }

      startVideos() {
        const videos = this.querySelectorAll('.category-circle-nav__video');
        if (!videos.length || this.videoObserver) return;

        if (!('IntersectionObserver' in window)) {
          videos.forEach((video) => this.playVideo(video));
          return;
        }

        this.videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.playVideo(entry.target);
              } else {
                entry.target.pause();
              }
            });
          },
          { rootMargin: '100px' }
        );

        videos.forEach((video) => this.videoObserver.observe(video));
      }

      stopVideos() {
        this.videoObserver?.disconnect();
        this.videoObserver = null;
        this.querySelectorAll('.category-circle-nav__video').forEach((video) => {
          video.pause();
          // Back to the poster frame, so nothing is left mid-motion on screen.
          video.currentTime = 0;
        });
      }

      playVideo(video) {
        if (video.preload === 'none') video.preload = 'auto';
        // Autoplay can still be refused (low power mode, for one). The poster
        // frame stays put in that case, so there is nothing to recover from.
        video.play().catch(() => {});
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onViewportChange);
        window.removeEventListener('resize', this.onViewportChange);
        document.removeEventListener('shopify:section:load', this.onSectionMutation);
        document.removeEventListener('shopify:section:unload', this.onSectionMutation);
        document.removeEventListener('shopify:section:reorder', this.onSectionMutation);
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
        document.removeEventListener('shopify:block:select', this.onSectionSelect);
        document.removeEventListener('shopify:block:deselect', this.onSectionDeselect);
        this.resizeObserver?.disconnect();
        window.clearTimeout(this.boundaryRefreshTimer);

        // stopVideos both disconnects and clears the observer. Only disconnecting
        // would leave the field truthy, and startVideos would then bail on
        // reattach and never resume playback.
        this.stopVideos();

        if (this.motionQuery && this.onMotionPreferenceChange) {
          if (this.motionQuery.removeEventListener) {
            this.motionQuery.removeEventListener('change', this.onMotionPreferenceChange);
          } else if (this.motionQuery.removeListener) {
            this.motionQuery.removeListener(this.onMotionPreferenceChange);
          }
          this.motionQuery = null;
          this.onMotionPreferenceChange = null;
        }

        cancelAnimationFrame(this.frame);
      }

      refreshBoundary() {
        const selector = this.dataset.stickyBoundarySelector.trim();
        this.boundary = null;

        if (selector && this.section) {
          try {
            this.boundary = Array.from(document.querySelectorAll(selector)).find((candidate) =>
              Boolean(this.section.compareDocumentPosition(candidate) & Node.DOCUMENT_POSITION_FOLLOWING)
            );
          } catch (error) {
            console.warn(`Category circle nav: invalid sticky boundary selector "${selector}".`, error);
          }
        }

        this.scheduleUpdate();
      }

      // Section events target an ancestor of this element; block events target a
      // descendant. Accept either direction so both selections count as editing.
      isSelectionForThis(event) {
        const target = event.target;
        if (!target || !target.contains) return false;
        return target.contains(this) || this.contains(target);
      }

      handleSectionSelect(event) {
        if (this.isSelectionForThis(event)) this.section?.classList.add('is-editor-selected');
      }

      handleSectionDeselect(event) {
        if (this.isSelectionForThis(event)) {
          this.section?.classList.remove('is-editor-selected');
          this.scheduleUpdate();
        }
      }

      scheduleUpdate() {
        if (this.ticking) return;
        this.ticking = true;
        this.frame = requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      }

      update() {
        if (!this.section) return;

        const stickyEnabled = this.dataset.sticky === 'true';
        const extraOffset = parseFloat(this.dataset.stickyOffset) || 0;

        // Measure the pinned chrome on its own. Folding the configured offset into
        // this running total would let the chrome's bottom edge swallow it, so a
        // 10px offset under a header ending at 100px would resolve to 100, not 110.
        let chromeBottom = 0;

        if (stickyEnabled && this.dataset.stickyHeaderOffset === 'true') {
          Array.from(document.querySelectorAll(stickyChromeSelector))
            .map((element) => ({ position: getComputedStyle(element).position, rect: element.getBoundingClientRect() }))
            .filter(({ position, rect }) => (position === 'sticky' || position === 'fixed') && rect.bottom > 0)
            .sort((first, second) => first.rect.top - second.rect.top)
            .forEach(({ rect }) => {
              if (rect.top <= chromeBottom + 1) chromeBottom = Math.max(chromeBottom, rect.bottom);
            });
        }

        const stickyTop = chromeBottom + extraOffset;

        // Every layout read happens before the first write. Setting the custom
        // property first invalidated layout, and the boundary rect and offsetHeight
        // reads immediately after forced a synchronous recalc on every scroll frame.
        const ownHeight = this.offsetHeight;
        const boundaryTop = stickyEnabled && this.boundary
          ? this.boundary.getBoundingClientRect().top
          : null;

        this.section.style.setProperty('--category-circle-nav-top', `${Math.max(0, stickyTop)}px`);
        this.section.classList.toggle(
          'is-past-sticky-boundary',
          boundaryTop !== null && boundaryTop <= stickyTop + ownHeight
        );
      }
    }

    customElements.define('category-circle-navigation', CategoryCircleNavigation);
  })();

  } catch(e) { console.error(e); }
})();
})();
